(function () {
    'use strict';

    angular
        .module('app')
        .controller('logOut', logOut);

    logOut.$inject = ['$location', 'loginService', '$state', 'sessionTimeoutService'];

    function logOut($location, loginService, $state, sessionTimeoutService) {

        // This function is called by state change.
        // If we went to the layout.logout from a sessionTimeout, we dont' need to call logout.
        var bTimedOut = sessionTimeoutService.checkForTimedOut();
        if (!bTimedOut) {
            /* jshint validthis:true */
            var vm = this;
            vm.title = 'logout';
            vm.loginService = loginService;
            loginService.logOut().then(function () {
                if (!loginService.oAuthEnabled) {
                    $state.go("login", { force: true });
                }
                else {
                    $state.go("oauth_logout");
                }
               
            }, function (error) {
                if (!loginService.oAuthEnabled) {
                    $state.go("login", { force: true }).then(function () {
                        console.log("log out failed");
                    });
                }
                else {
                    $state.go("oauth_logout");
                }
            })
        }
        else {
            $state.go("login", { force: true });
        }
        
    }
})();
